import { useSelector } from 'react-redux'

import { RootState } from 'types'

export const useArticleMeta = (key: string | null) =>
  useSelector(({ articleMeta }: RootState) => (key ? articleMeta[key] : null))
